import * as yup from "yup";

export const groupValidationSchema = yup.object({
  model: yup
    .string("Enter model name or serial number")
    .required("Enter model name or serial number")
    .typeError("Invalid type")
    .nullable(),
  group: yup.string("Enter group").nullable().required("Group is required"),
  site: yup.string("Enter site").nullable().required("Site is required"),
  building: yup.string("Enter building").nullable(),
  floor: yup.string("Enter floor").nullable(),
  room: yup.string("Enter room").nullable(),
});
